import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	enableBackground: "new 0 0 20 20",
	height: "48px",
	viewBox: "0 0 20 20",
	width: "48px",
	fill: "#000000",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
		fill: "none",
		height: 20,
		width: 20,
		x: 0
	}) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M16,6v10.5c0,0.83-0.67,1.5-1.5,1.5h-9C4.67,18,4,17.33,4,16.5v-13C4,2.67,4.67,2,5.5,2H12L16,6z M14.5,16.5V7H11V3.5H5.5 v13H14.5z M11.5,10.5c0-0.28-0.22-0.5-0.5-0.5H7.5C7.22,10,7,10.22,7,10.5V14c0,0.28,0.22,0.5,0.5,0.5H11c0.28,0,0.5-0.22,0.5-0.5 v-1.05C12.22,13.45,13,14,13,14v-3.5l-1.5,1.05V10.5z" }) })]
});
export default SvgVideoFile;
